import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import { styled, Typography } from '@mui/material';

import banner_403 from 'Assets/images/banner_403.svg';
import { Link, SingleLine } from 'Components';
import { Colors } from 'Themes/colors';
import { Spacing } from 'Themes/spacing';

import { CloseIconButton } from '../CloseIconButton';
import {
  ButtonLink,
  LeftColumn,
  StyledContainer,
  StyledMuiLink,
  Wrapper
} from '../NotFoundPage/NotFoundPage.styles';

const StyledImg = styled('img')`
  max-height: 450px;
`;

const StyledCloseButton = styled(CloseIconButton)`
  position: absolute !important;
  top: ${Spacing.small};
  right: ${Spacing.small};
`;

export const ForbiddenPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleBackClick = () => window.history.back();
  const handleCloseClick = () => navigate('/');

  return (
    <StyledContainer>
      <Wrapper>
        <LeftColumn>
          <Typography>{t('forbiddenPage.title')}</Typography>
          <Typography fontSize="164px" fontWeight={700} color={Colors.black}>
            403
          </Typography>
          <Typography>{t('forbiddenPage.firstLine')}</Typography>
          <SingleLine>
            <ButtonLink onClick={handleBackClick}>{t('forbiddenPage.backButton')}</ButtonLink>
            <Typography>{t('forbiddenPage.secondLine')}</Typography>
            <Link to="/" label={t('forbiddenPage.mainPage')} />
          </SingleLine>
          <SingleLine>
            <Typography>{t('forbiddenPage.thirdLine')}</Typography>
            <StyledMuiLink href="mailto:kontakt@treneo.pl">kontakt@treneo.pl</StyledMuiLink>
          </SingleLine>
        </LeftColumn>
        <StyledImg src={banner_403} alt="banner 403"></StyledImg>
        <StyledCloseButton onClose={handleCloseClick} />
      </Wrapper>
    </StyledContainer>
  );
};
